import React from "react";
interface HammerIconProps {
  className?: string;
}

function HammerIcon({ className }: HammerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 71 69"
    >
      <g filter="url(#filter0_d_225_8374)">
        <circle cx="35.5" cy="31.5" r="17.5" fill="#fff"></circle>
      </g>
      <g clipPath="url(#clip0_225_8374)">
        <path
          fill="#FF752C"
          d="M31.381 31.681a.875.875 0 010-1.237l3.5-3.5a.875.875 0 111.238 1.237l-3.5 3.5a.875.875 0 01-1.238 0zm10.425.95a.875.875 0 00-1.237 0l-3.5 3.5a.875.875 0 101.237 1.238l3.5-3.5a.875.875 0 000-1.238zm-1.92-.864l-2.903-2.903a.219.219 0 00-.31 0l-3.372 3.372a.22.22 0 000 .31l.832.832-4.064 4.066a.875.875 0 001.237 1.237l4.066-4.063.833.832a.218.218 0 00.31 0l3.371-3.372a.219.219 0 000-.31z"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_d_225_8374"
          width="70"
          height="70"
          x="0.5"
          y="-1.167"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="2.333"></feOffset>
          <feGaussianBlur stdDeviation="8.75"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0.383333 0 0 0 0 0.383333 0 0 0 0 0.383333 0 0 0 0.25 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_225_8374"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_225_8374"
            result="shape"
          ></feBlend>
        </filter>
        <clipPath id="clip0_225_8374">
          <path
            fill="#fff"
            d="M0 0H14V14H0z"
            transform="translate(28.5 26.25)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default HammerIcon;
